export default __webpack_public_path__ + "static/article-how-to-make-debt-work-for-you-ca0ffda6e040cb9828cce48e4e721e6f.jpg";